import React from "react";
import { TradingProvider } from "../context/TradingContext";
import { CurrencySelectionProvider } from "../context/CurrencySelectionContext";

const TradingLayout = ({ children }) => {
  return (
    <TradingProvider>
      <CurrencySelectionProvider>{children}</CurrencySelectionProvider>
    </TradingProvider>
  );
};

export default TradingLayout;
